import application from './application';
import ClassSwitcherController from './class_switcher_controller';

application.register('class-switcher', ClassSwitcherController);
